export enum AllergySource {
    Class = 1,
    Ingredient = 2,
    Other = 3
}
